export const ConfigReducer = (state, action) => {
    switch (action.type) {
        case "GET_CAPABILITIES":
            return {
                ...state,
                capability: action.capability
            };
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/global/reducers/ConfigReducer.js